import type { TagDetailItem } from '@/entities/tags/domain/types';

import { getTagsApi } from './getTagsApi';

type SearchTagsParams = {
  parent: string;
  query?: string;
  provider?: 'system' | 'user';
};

const filterTagsByQuery = (tags: TagDetailItem[], query: string): TagDetailItem[] => {
  if (!query) return tags;

  const lowerQuery = query.toLowerCase();

  return tags.filter((tag) => {
    const nameMatch = tag.name?.toLowerCase().includes(lowerQuery);
    const displayNameMatch = tag.displayName?.toLowerCase().includes(lowerQuery);
    const descriptionMatch = tag.description?.toLowerCase().includes(lowerQuery);

    return nameMatch || displayNameMatch || descriptionMatch;
  });
};

export const searchTagsApi = async ({
  parent,
  query = '',
  provider,
}: SearchTagsParams): Promise<{ data: TagDetailItem[]; paging: { total: number } }> => {
  const response = await getTagsApi({ parent, limit: 3000, fields: 'usageCount' });

  let filteredData = response.data;

  filteredData = filteredData.filter((tag) => !tag.disabled);

  if (provider) {
    filteredData = filteredData.filter((tag) => tag.provider === provider);
  }

  if (query) {
    filteredData = filterTagsByQuery(filteredData, query);
  }

  return {
    data: filteredData,
    paging: {
      total: filteredData.length,
    },
  };
};
